import React from 'react';
import EstatePlanningView from "./EstatePlanningView"
function EstatePlanning(props) {
    return (
        <EstatePlanningView/>
    );
}

export default EstatePlanning;
